import type { FC } from 'react';

import * as Styled from './super-ellipse-with-badge.styled';

type SuperEllipseWhenTopBarProps = {
  type: 'avatar';
  size: 'xsmall' | 'small';
};

type SuperEllipseWithBadgeProps = {
  count: number;
};

const SuperEllipseWhenTopBar: React.FC<SuperEllipseWhenTopBarProps> = (
  props
) => {
  return (
    <>
      <Styled.SuperEllipseWhenTopBar {...props} $size="xsmall" size="xsmall" />
      <Styled.SuperEllipseWhenTopBar {...props} $size="small" size="small" />
    </>
  );
};

export const SuperEllipseWithBadge: FC<SuperEllipseWithBadgeProps> = ({
  count,
}) => {
  return (
    <Styled.SuperEllipseWrapper>
      <SuperEllipseWhenTopBar type="avatar" size="small" />
      {count ? (
        <Styled.NotificationBadgeWithCount>
          {count}
        </Styled.NotificationBadgeWithCount>
      ) : null}
    </Styled.SuperEllipseWrapper>
  );
};
